import type { UserStatus } from "../../types/user";

const STATUS_STYLES: Record<UserStatus, string> = {
  pending: "bg-brand-desert text-text-primary",
  active: "bg-bg-secondary text-text-primary",
  disabled: "bg-bg-secondary text-text-tertiary",
};

const STATUS_LABELS: Record<UserStatus, string> = {
  pending: "Pending",
  active: "Active",
  disabled: "Disabled",
};

interface StatusBadgeProps {
  status: UserStatus;
}

export function StatusBadge({ status }: Readonly<StatusBadgeProps>) {
  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium ${STATUS_STYLES[status]}`}
    >
      {STATUS_LABELS[status]}
    </span>
  );
}
